import { ReactComponent as Youtube } from 'assets/icons/logo-youtube.svg';
import { SVGProps } from 'react';

const YoutubeIcon = (props?: SVGProps<SVGSVGElement>) => {
  return (
    <Youtube {...props} style={{ height: 30, width: 30, ...props?.style }} />
  );
};

export default YoutubeIcon;
